export default "\r\n<app-membership-type-list></app-membership-type-list>\r\n\r\n\r\n";